// extracted by mini-css-extract-plugin
module.exports = {"container":"ex-z","links":"fx-z"};